import type { CommentStatus } from '../types/community';

const STATUS_LABELS: Record<CommentStatus, string> = {
  Draft: 'مسودة',
  Pending: 'قيد المراجعة',
  Approved: 'منشور',
  Rejected: 'مرفوض',
};

const STATUS_STYLES: Record<CommentStatus, string> = {
  Draft: 'bg-gray-100 text-gray-600',
  Pending: 'bg-amber-100 text-amber-700',
  Approved: 'bg-green-100 text-green-700',
  Rejected: 'bg-red-100 text-red-700',
};

const REPLIER_LABELS: Record<string, string> = {
  Teacher: 'المعلم',
  Assistant: 'المساعد',
  Moderator: 'فريق الدعم العلمي للمنصة',
};

export const MODERATOR_REPLY_DISPLAY_NAME = 'فريق الدعم العلمي للمنصة';

export function getCommentStatusLabel(status: CommentStatus | string): string {
  return STATUS_LABELS[status as CommentStatus] ?? status;
}

export function getCommentStatusStyle(status: CommentStatus | string): string {
  return STATUS_STYLES[status as CommentStatus] ?? STATUS_STYLES.Draft;
}

export function getReplierLabel(repliedBy: string): string {
  return REPLIER_LABELS[repliedBy] ?? repliedBy;
}

export function getReplyDisplayName(reply: {
  repliedBy: string;
  replierName?: string | null;
}): string {
  if (reply.repliedBy === 'Moderator') {
    return MODERATOR_REPLY_DISPLAY_NAME;
  }
  return reply.replierName?.trim() || getReplierLabel(reply.repliedBy);
}

export function formatCommentDate(iso: string): string {
  try {
    // Backend stores UTC; SQL/JSON often omits "Z", so browsers treat it as local.
    // Normalize naive timestamps as UTC, then show Egypt time (UTC+3).
    const trimmed = iso.trim();
    const hasZone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(trimmed);
    const normalized =
      !hasZone && trimmed.includes('T') ? `${trimmed}Z` : trimmed;

    return new Date(normalized).toLocaleDateString('ar-EG', {
      timeZone: 'Africa/Cairo',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}
